import React from 'react';
import MDBox from "materialDashboard/components/MDBox";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";

export const IncidentTotals = ({totals, allStatisticsPath = null}) => {
    const {t} = useTranslation(["incidents"]);

    const navigate = useNavigate();
    if (!totals) {
        return null;
    }

    return <MDBox padding={1} margin={3} bgColor="#f8f9fa" borderRadius={"8px"} sx={{
        display: 'flex',
        gap: 3,
        flexWrap: 'wrap',
        alignItems: "center",
        justifyContent: 'space-between',
        flexDirection: {xs: 'column', sm: 'row'}
    }}>
        <Typography sx={{fontSize: "0.65rem", textTransform: 'uppercase'}}><b>{t("totals.totals")}:</b></Typography>
        <Typography sx={{
            fontSize: "0.65rem",
            textTransform: 'uppercase'
        }}>{t("totals.numberOfIncidents")}: <b>{totals.totalIncidents}</b></Typography>
        <Typography sx={{
            fontSize: "0.65rem",
            textTransform: 'uppercase'
        }}>{t("totals.numberOfPeopleInvolved")}: <b>{totals.totalPeopleInvolved}</b></Typography>
        <Typography sx={{
            fontSize: "0.65rem",
            textTransform: 'uppercase'
        }}>{t("totals.numberOfPeopleCaught")}: <b>{totals.totalPeopleCaught}</b></Typography>
        <Typography sx={{
            fontSize: "0.65rem",
            textTransform: 'uppercase'
        }}>{t("totals.numberOfInjured")}: <b>{totals.totalInjured}</b></Typography>
        <Typography sx={{
            fontSize: "0.65rem",
            textTransform: 'uppercase'
        }}>{t("totals.numberOfUninjured")}: <b>{totals.totalUninjured}</b></Typography>
        <Typography sx={{
            fontSize: "0.65rem",
            textTransform: 'uppercase'
        }}>{t("totals.numberOfDeaths")}: <b>{totals.totalDeaths}</b></Typography>
        {
            allStatisticsPath && <Button onClick={() => navigate(allStatisticsPath)} variant="text" size="small">
                {t("totals.viewAllStatistics")}
            </Button>
        }
    </MDBox>;
}
export default IncidentTotals;